(() => {
  if (window.LTPickupRequestLoaded) return;
  window.LTPickupRequestLoaded = true;
  const propertyNames = {
    location: 'Requested pickup location',
    date: 'Requested pickup date',
    window: 'Requested pickup window',
    notes: 'Notes for this item',
  };
  const westJordan = 'West Jordan';
  const riverdale = 'Riverdale';
  const westWindows = {
    weekday: ['Tue–Fri: 12–3 pm', 'Tue–Fri: 3–6 pm'],
    saturday: ['Sat: 10 am–1 pm', 'Sat: 1–4 pm'],
  };

  const fields = (root) => ({
    toggle: root.querySelector('[data-lt-pickup-request-toggle]'),
    fields: root.querySelector('[data-lt-pickup-fields]'),
    location: root.querySelector('[data-lt-pickup-location]'),
    date: root.querySelector('[data-lt-pickup-date]'),
    windowWrap: root.querySelector('[data-lt-pickup-window-wrap]'),
    window: root.querySelector('[data-lt-pickup-window]'),
    help: root.querySelector('[data-lt-pickup-location-help]'),
    notes: root.querySelector('[data-lt-pickup-notes]'),
  });

  const dateWindows = (date) => {
    if (!date) return [];
    const day = new Date(`${date}T12:00:00`).getDay();
    if (day >= 2 && day <= 5) return westWindows.weekday;
    if (day === 6) return westWindows.saturday;
    return [];
  };

  const updateWindow = (fieldSet) => {
    const { location, date, window: windowInput } = fieldSet;
    if (!windowInput) return;
    const current = windowInput.dataset.ltPickupCurrentWindow || windowInput.value;
    const options = location.value === westJordan ? dateWindows(date.value) : [];
    windowInput.replaceChildren(new Option(options.length ? 'Choose a time window' : 'Choose a valid date first', ''));
    options.forEach((value) => windowInput.add(new Option(value, value)));
    if (options.includes(current)) windowInput.value = current;
    delete windowInput.dataset.ltPickupCurrentWindow;
  };

  const sync = (root) => {
    const fieldSet = fields(root);
    if (!fieldSet.toggle) return;
    const requested = fieldSet.toggle.checked;
    const isWestJordan = requested && fieldSet.location.value === westJordan;
    const isRiverdale = requested && fieldSet.location.value === riverdale;

    fieldSet.fields.hidden = !requested;
    fieldSet.location.disabled = !requested;
    fieldSet.date.disabled = !requested;
    fieldSet.location.required = requested;
    fieldSet.date.required = requested;
    fieldSet.windowWrap.hidden = !isWestJordan;
    fieldSet.window.disabled = !isWestJordan;
    fieldSet.window.required = isWestJordan;
    if (isWestJordan) updateWindow(fieldSet);

    if (isWestJordan && !dateWindows(fieldSet.date.value).length && fieldSet.date.value) {
      fieldSet.help.textContent = 'West Jordan pickup is available Tue–Fri, 12–3 pm or 3–6 pm; Sat, 10 am–1 pm or 1–4 pm.';
    } else if (isWestJordan) {
      fieldSet.help.textContent = 'West Jordan: Tue–Fri, 12–3 pm or 3–6 pm; Sat, 10 am–1 pm or 1–4 pm.';
    } else if (isRiverdale) {
      fieldSet.help.textContent = 'Riverdale is scheduled pickup only. Add a specific time request in the notes if needed.';
    } else {
      fieldSet.help.textContent = '';
    }
  };

  const clearPickupFields = (fieldSet) => {
    fieldSet.location.value = '';
    fieldSet.date.value = '';
    fieldSet.window.value = '';
    delete fieldSet.window.dataset.ltPickupCurrentWindow;
  };

  const productValid = (root) => {
    sync(root);
    const fieldSet = fields(root);
    if (!fieldSet.toggle.checked) return true;
    if (fieldSet.location.value === westJordan && !dateWindows(fieldSet.date.value).length) {
      fieldSet.date.setCustomValidity('Choose a Tuesday through Saturday for West Jordan pickup.');
    } else {
      fieldSet.date.setCustomValidity('');
    }
    const valid = [fieldSet.location, fieldSet.date, fieldSet.window].every((input) => !input || input.disabled || input.checkValidity());
    if (!valid) {
      [fieldSet.location, fieldSet.date, fieldSet.window].find((input) => input && !input.disabled && !input.checkValidity())?.reportValidity();
    }
    return valid;
  };

  const lineProperties = (root) => {
    const fieldSet = fields(root);
    let properties = {};
    try {
      properties = JSON.parse(root.dataset.ltPickupProperties || '{}');
    } catch (_) {
      throw new Error('Pickup details could not be read. Refresh the cart and try again.');
    }
    const requested = fieldSet.toggle.checked;
    if (requested) {
      properties[propertyNames.location] = fieldSet.location.value;
      properties[propertyNames.date] = fieldSet.date.value;
      if (fieldSet.location.value === westJordan) properties[propertyNames.window] = fieldSet.window.value;
      else delete properties[propertyNames.window];
    } else {
      [propertyNames.location, propertyNames.date, propertyNames.window].forEach((name) => delete properties[name]);
    }
    if (fieldSet.notes.value.trim()) properties[propertyNames.notes] = fieldSet.notes.value.trim();
    else delete properties[propertyNames.notes];
    return properties;
  };

  const setStatus = (root, message) => {
    const status = root.querySelector('[data-lt-pickup-status]');
    if (status) status.textContent = message;
  };

  const sectionsToRender = (root) => {
    const drawerItems = root.closest('cart-drawer-items');
    if (drawerItems) return drawerItems.getSectionsToRender();
    const cartItems = root.closest('cart-items');
    if (cartItems) return cartItems.getSectionsToRender();
    throw new Error('Pickup request could not find its cart surface. Refresh the cart and try again.');
  };

  const saveLine = async (root) => {
    if (!productValid(root)) return false;
    const button = root.querySelector('[data-lt-pickup-save]');
    button.disabled = true;
    setStatus(root, 'Saving pickup request…');
    try {
      const sections = sectionsToRender(root);
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          id: root.dataset.ltPickupLineKey,
          quantity: Number(root.dataset.ltPickupQuantity),
          properties: lineProperties(root),
          sections: sections.map((section) => section.section),
          sections_url: window.location.pathname,
        }),
      });
      const cart = await response.json();
      if (!response.ok || cart.errors) throw new Error('Pickup request could not be saved.');
      renderCartSections(sections, cart);
      return true;
    } catch (error) {
      setStatus(root, error.message || 'Pickup request could not be saved.');
      button.disabled = false;
      return false;
    }
  };

  const renderCartSections = (sections, cart) => {
    sections.forEach((section) => {
      const container = document.getElementById(section.id);
      const html = cart.sections?.[section.section];
      if (!container || !html) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      const target = container.querySelector(section.selector) || container;
      if (source && target) target.innerHTML = source.innerHTML;
    });
    bindAll();
  };

  const bind = (root) => {
    if (root.dataset.ltPickupBound === 'true') return;
    root.dataset.ltPickupBound = 'true';
    const fieldSet = fields(root);
    sync(root);
    [fieldSet.toggle, fieldSet.location, fieldSet.date, fieldSet.window].filter(Boolean).forEach((input) => {
      input.addEventListener('change', () => {
        if (input === fieldSet.toggle && !input.checked) clearPickupFields(fieldSet);
        sync(root);
      });
    });
    root.querySelector('[data-lt-pickup-save]')?.addEventListener('click', () => saveLine(root));
  };

  const bindAll = () => {
    document.querySelectorAll('[data-lt-pickup-request-product], [data-lt-pickup-request-line]').forEach(bind);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form');
    const root = form?.querySelector('[data-lt-pickup-request-product]');
    if (root && !productValid(root)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    bindAll();
  });
})();
